import { Pencil, Lock } from 'lucide-react';

export const QUOTE_STATUSES = {
  draft: {
    label: 'Draft',
    icon: Pencil,
    iconClass: 'text-gray-400',
    badgeClass: 'bg-gray-700 text-gray-300',
    description: 'Editable — work in progress',
  },
  ready: {
    label: 'Ready',
    icon: Lock,
    iconClass: 'text-amber-400',
    badgeClass: 'bg-amber-900/40 text-amber-400',
    description: 'Locked for review — unlock to edit',
  },
  final: {
    label: 'Final',
    icon: Lock,
    iconClass: 'text-green-400',
    badgeClass: 'bg-green-900/40 text-green-400',
    description: 'Immutable — shared or exported',
  },
} as const;
